import { Injectable } from '@angular/core';
import { EntityStore, StoreConfig } from '@datorama/akita';

import { AuthAccountUserState } from './auth-account-user.state';

@Injectable({providedIn: 'root'})
@StoreConfig({ name: 'authAccountUsers', resettable: true, idKey: 'id' })
export class AuthAccountUserStore extends EntityStore<AuthAccountUserState> {
  constructor() {
    super();
  }
}
